import Helpers from '../helpers';
import Cookie from 'cookies-js';

class wsClient {
    constructor() {
        this.buffer = [];
        this.connection = false;
    }



    configure(params) {
        this.sid = false;
        this.reconnectCount = 1;
        this.connectionErrorNext = 0;
        this.user = params.user || false;
        this.info = params.info || false;  
        this.account = params.account || false;   

        this.messageHandler = params.messageHandler;
        this.connect();
        
        this.connectionMonitor = setInterval(() => {
            if(!this.isConnected()) {

                if(typeof this.messageHandler.onDisconnect == 'function') {
                    this.messageHandler.onDisconnect();
                }

                this.reconnectCount++;

                if(this.reconnectCount >= this.connectionErrorNext) {
                    this.connectionErrorNext = (this.reconnectCount*(this.reconnectCount-1));
                    this.removeEvents();
                    this.connect();
                }  
            }else{
                this.reconnectCount = 1;
                this.connectionErrorNext = 0;
                this.messageHandler.onConnected();
            }
        },4000);  
    }

    isConnected() {
        if(!this.connection) {
            return false;
        }
        if(this.connection.readyState == '1') {
            return true;
        }else{
            return false;
        }
    }

    connect() {
        this.sid = Helpers.randomStr();
        let url = Helpers.url().ws+"/socket?sid="+this.sid;
        if(this.user != false) {
            url += '&a';
        }

        this.connection = new WebSocket(url);
        this.bindEvents();
    }

    connected(sid) {
        this.sid = sid;
    }

    beacon() {
        let data = {};

        if(this.user) {
            data.user = this.user;
        }

        if(this.info) {
            data.info = this.info;
        }

        if(this.account) {
            data.account = this.account;
        }


        data.uid = Cookie.get('crall_uid');

        this.sendMessage('beacon',data);

        if(typeof this.messageHandler.onReady == 'function') {
            this.messageHandler.onReady();
        }

    }

    removeEvents() {
        this.connection.onopen=function () {};

        this.connection.onerror=function () {};
        this.connection.onclose = function () {};

        this.connection.onmessage = function () {};

        window.onbeforeunload = () => {
            this.connection.onclose = function () {};
        };
    
    }


    bindEvents() {
        this.connection.onopen = (event) => {
            this.beacon();
        } 

        this.connection.onerror=function(event){
        }
        this.connection.onclose = () => {
            this.connection.close();
        }

        this.connection.onmessage = (event) => {
            this.parseIncomingMessage(event.data);
        }

        window.onbeforeunload = () => {
            this.connection.onclose = function () {};
            clearInterval(this.connectionMonitor);
            this.connection.close()
        };
    }

    send(action,data = false) {
        if(this.isConnected()) {
            let out = {'action':action};
            if(data) {
                out.data = data;
            }

            this.connection.send(JSON.stringify(out));
        }else{
            this.buffer.push({'action':action,data:data});
        }
    }

    disconnect() {
        if(typeof this.messageHandler.onDisconnect == 'function') {
            this.messageHandler.onDisconnect();
        }
        clearInterval(this.connectionMonitor);
        this.connected = false;
        this.connection.close();
    }

    broadcastMessage(action,data) {
        this.parent.emit(action,data);
    }

    sendMessage(action,data = {}) {
        let payload = {};
        payload.action = action;
        payload.payload = data;
        payload.sender = this.sid;
        this.connection.send(JSON.stringify(payload));
    }

    parseIncomingMessage(data) {
        this.connected = true;

        if(data == '1') {
            return true;
        }
        data = JSON.parse(data);

       // this.broadcastMessage(data.action,data);

        if(typeof this[data.action] == 'function') {
            this[data.action](data);
            return true;
        }

        if(typeof this.messageHandler[data.action] == 'function') {
            this.messageHandler[data.action](data);
            return true;
        }
    
    }

    connected(data) {

    }

    init(data) {
        Cookie.set('crall_uid', data.payload.uid);
        this.buffer.map(item => {
            this.send(item.action,item.data);
        });

        if(typeof this.messageHandler['setOnlineStatus'] == 'function' && typeof data.payload.online !== 'undefined') {
            this.messageHandler['setOnlineStatus'](data.payload.online);
        }

        if(typeof this.messageHandler['setSettings'] == 'function' && typeof data.payload.settings !== 'undefined') {
            this.messageHandler['setSettings'](data.payload.settings);
        }



        this.buffer = [];
    }
}

export default wsClient;


// WEBPACK FOOTER //
// /home/fabian/development/crall/www/lib/wsclient/index.js